import NotFoundPrivate from '@/features/NotFound/NotFoundPrivate';

const NotFoundPrivatePage = () => {
  return <NotFoundPrivate />;
};

export default NotFoundPrivatePage;
